import React, {useState, useCallback, useEffect} from "react";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";
import styles from "./styles/livestreams-data.css.js";
import withStyles from "components/with-styles";
import LiveStreamData from "./livestream-data";
import FormConfirm from "components/form/form-confirm";
import {RTMPAddLivestreamAction} from "../forms/common-forms/livestream-form";
import {PageSection, PageHeaderBar} from "components/page";
import {eventStatusTypes} from "pages/event/utils";
import {updateLivestreamsActionCreator} from "../../../actions/common-actions";
import {connect} from "react-redux";
import {compose} from "redux";

const LiveStreamsData = ({classes, intl, event, updateLivestreams}) => {
    const eventStatus = event?.eventStatus;
    const showAddLivestreamAction = [eventStatusTypes.STARTING, eventStatusTypes.STARTED].includes(eventStatus);

    const [success, setSuccess] = useState(false);
    const [show, setShow] = useState(false);

    const handleCloseConfirm = useCallback(() => setShow(false), []);

    const handleAction = success => {
        setSuccess(success);
        setShow(true);
    };

    useEffect(() => {
        if (event?.liveStreams) {
            updateLivestreams(event.liveStreams)
        }
    }, [event?.liveStreams])

    return (
        <PageSection hideBackground>
            <PageHeaderBar
                buttons={
                    showAddLivestreamAction ? (
                        <RTMPAddLivestreamAction
                            eventId={event.id}
                            onSuccess={() => {
                                setSuccess(true);
                                setShow(true);
                            }}
                            onError={() => {
                                setSuccess(false);
                                setShow(true);
                            }}
                        />
                    ) : null
                }
            />
            <FormConfirm
                className={classes.confirm}
                autoHideDuration={2000}
                show={show}
                error={!success}
                success={success}
                onClose={handleCloseConfirm}
                hideCloseButton={false}
                label={
                    success ? intl.formatMessage({id: "event.rtmp.successful"}) : intl.formatMessage({id: "event.rtmp.error"})
                }
            />
            {event.liveStreams &&
            event.liveStreams.map(liveStream => (
                <LiveStreamData event={event} key={liveStream.key} liveStream={liveStream} onAction={handleAction}/>
            ))}
        </PageSection>
    );
};

LiveStreamsData.propTypes = {
    /**
     * Evento
     **/
    event: PropTypes.object,
};

const mapDispatchToProps = dispatch => ({
    updateLivestreams: (data) => dispatch(updateLivestreamsActionCreator(data))
});

export default compose(withStyles(styles), injectIntl, connect(null, mapDispatchToProps))(LiveStreamsData);
